import { render, staticRenderFns } from "./CustomerNetForm.vue?vue&type=template&id=2965110e"
import script from "./CustomerNetForm.vue?vue&type=script&lang=ts"
export * from "./CustomerNetForm.vue?vue&type=script&lang=ts"
import style0 from "./CustomerNetForm.vue?vue&type=style&index=0&id=2965110e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports